import React from 'react';
import classNames from 'classnames';
import styles from './Container.module.scss';

interface Container extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Width of the container
   */
  containerWidth?: 'fixed' | 'fluid' | 'full';
  padding?: boolean;
  className?: string;
}

const Container: React.FC<Container> = ({
  containerWidth = 'fixed',
  padding = true,
  children,
  className,
  ...props
}) => {
  return (
    <div
      {...props}
      className={classNames(
        styles.container,
        {
          [styles.fixed]: containerWidth === 'fixed',
          [styles.full]: containerWidth === 'full',
          [styles.noPadding]: !padding
        },
        className
      )}
    >
      {children}
    </div>
  );
};

export default Container;
